 // <span class="wk-link__label">{{ locale.wishlist }}</span> line #10
// <span class="wk-link__count">{{ wishlist.item_count }}</span> line#11

const templates = [
  {
    id: "wishlist-link",
    data: "wishlist",
    
    template: `
      <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}">
        <div class="wk-icon wk-link__icon dddddd">{% include "wishlist-icon" %}</div>       
      </a>
    `,
  },
  {
    id: "wishlist-button",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        // const variantInput = document.querySelector("form *[name='id']");
        // const variantId = variantInput ? variantInput.value : undefined;
const variantId = $('input[name="option-0"]:checked').attr("varint_id");

        
$('.wishlist_alert').addClass("show");
        
$('.wishlist_alert a').show(); 
$('.wishlist_alert .wishlist_alert_text').text('Item saved to your wishlist');
        
setTimeout(function() {
    $('.wishlist_alert').removeClass("show");
}, 5000);
        
$('.wishlist_alert').removeClass("wishlist_alert_error");
        
console.log("one");


  var  fsb_height_wishlist = 0;
   var  header_height_wishlist = 0;
    
    var header_top_of_element = $("#shopify-section-header").offset().top;
    var header_bottom_of_element = $("#shopify-section-header").offset().top + $("#shopify-section-header").outerHeight();
    var header_bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var header_top_of_screen = $(window).scrollTop();
    if ((header_bottom_of_screen > header_top_of_element) && (header_top_of_screen < header_bottom_of_element)){
        var header_height_wishlist = $("#shopify-section-header").height();
        // console.log("header is visible, do something",$("#shopify-section-header").height());
    } else {
        
    }

 var fsb_top_of_element = $("#free-shipping-bar-row").offset().top;
    var fsb_bottom_of_element = $("#free-shipping-bar-row").offset().top + $("#free-shipping-bar-row").outerHeight();
    var fsb_bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var fsb_top_of_screen = $(window).scrollTop();

    if ((fsb_bottom_of_screen > fsb_top_of_element) && (fsb_top_of_screen < fsb_bottom_of_element)){
         fsb_height_wishlist = $("#free-shipping-bar-row").height();
        // console.log("fsb is visible, do something",$("#free-shipping-bar-row").height());
    } else {
    }

    $(".wishlist_alert").css("top",fsb_height_wishlist + header_height_wishlist + 15);








        

        
        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        ).then(product => {
          const variant = product.variants.find(variant => variant.id.toString() === variantId) || product.variants[0];
          
          gtag("event", "add_to_wishlist", {
            currency: Shopify.currency.active,
            value: variant.price,
            items: [
              {
                item_id: variant.sku || variant.id,
                item_name: product.title,
                affiliation: "Wishlist King",
                item_category: product.type,
                item_brand: product.vendor,
                item_variant: variant.title,
                item_quantity: 1,
                item_price: variant.price,
              },
            ],
          });
        });
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();


        
$('.wishlist_alert').addClass("show");
        $('.wishlist_alert a').show(); 
$('.wishlist_alert .wishlist_alert_text').text('Item removed from your wishlist');	
setTimeout(function() {
    $('.wishlist_alert').removeClass("show");
}, 5000);
$('.wishlist_alert').removeClass("wishlist_alert_error");


console.log("two");


  var  fsb_height_wishlist = 0;
   var  header_height_wishlist = 0;
    
    var header_top_of_element = $("#shopify-section-header").offset().top;
    var header_bottom_of_element = $("#shopify-section-header").offset().top + $("#shopify-section-header").outerHeight();
    var header_bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var header_top_of_screen = $(window).scrollTop();
    if ((header_bottom_of_screen > header_top_of_element) && (header_top_of_screen < header_bottom_of_element)){
        var header_height_wishlist = $("#shopify-section-header").height();
        // console.log("header is visible, do something",$("#shopify-section-header").height());
    } else {
        
    }

 var fsb_top_of_element = $("#free-shipping-bar-row").offset().top;
    var fsb_bottom_of_element = $("#free-shipping-bar-row").offset().top + $("#free-shipping-bar-row").outerHeight();
    var fsb_bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var fsb_top_of_screen = $(window).scrollTop();

    if ((fsb_bottom_of_screen > fsb_top_of_element) && (fsb_top_of_screen < fsb_bottom_of_element)){
         fsb_height_wishlist = $("#free-shipping-bar-row").height();
        // console.log("fsb is visible, do something",$("#free-shipping-bar-row").height());
    } else {
    }

    $(".wishlist_alert").css("top",fsb_height_wishlist + header_height_wishlist + 15);




        
        
        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

$('.wishlist_alert').addClass("show");
        $('.wishlist_alert a').hide(); 
$('.wishlist_alert .wishlist_alert_text').text('Item removed from your wishlist page');	
setTimeout(function() {
    $('.wishlist_alert').removeClass("show");
}, 5000);
$('.wishlist_alert').removeClass("wishlist_alert_error");

console.log("three");

  var  fsb_height_wishlist = 0;
   var  header_height_wishlist = 0;
    
    var header_top_of_element = $("#shopify-section-header").offset().top;
    var header_bottom_of_element = $("#shopify-section-header").offset().top + $("#shopify-section-header").outerHeight();
    var header_bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var header_top_of_screen = $(window).scrollTop();
    if ((header_bottom_of_screen > header_top_of_element) && (header_top_of_screen < header_bottom_of_element)){
        var header_height_wishlist = $("#shopify-section-header").height();
        // console.log("header is visible, do something",$("#shopify-section-header").height());
    } else {
        
    }

 var fsb_top_of_element = $("#free-shipping-bar-row").offset().top;
    var fsb_bottom_of_element = $("#free-shipping-bar-row").offset().top + $("#free-shipping-bar-row").outerHeight();
    var fsb_bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var fsb_top_of_screen = $(window).scrollTop();

    if ((fsb_bottom_of_screen > fsb_top_of_element) && (fsb_top_of_screen < fsb_bottom_of_element)){
         fsb_height_wishlist = $("#free-shipping-bar-row").height();
        // console.log("fsb is visible, do something",$("#free-shipping-bar-row").height());
    } else {
    }

    $(".wishlist_alert").css("top",fsb_height_wishlist + header_height_wishlist + 15);

        
   




        
        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}

      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wk-button__icon">
        <svg class="wk-icon__svg" viewBox="0 0 200 200"> 
          <path d="M142.347,9.584L142.347,9.584c-13.189,0-25.686,4.165-35.057,12.148c-2.43,2.083-4.859,4.166-7.289,6.248l0,0
          	c-3.818-3.818-7.983-7.289-12.842-10.065l0,0l0,0c-9.024-5.207-19.09-7.983-29.156-7.983h-0.694c-19.09,0-35.75,9.371-46.51,25.337
          	C-0.655,52.623-2.39,74.837,5.593,93.58c15.272,38.18,56.576,70.458,86.425,91.632l7.983,5.554l7.983-5.554
          	c25.685-17.702,60.047-45.469,79.483-77.054c9.72-16.313,13.536-30.892,11.802-45.816c-1.735-14.925-6.942-26.379-15.967-35.403
          	C172.891,15.832,157.966,9.584,142.347,9.584L142.347,9.584z"/>
          </svg> 
        </div>
        <span class="wk-button__label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-floating",
    data: "product",
    template: `
      {% include "wishlist-button" addClass: "wk-button--floating" %}
    `,
  },
  {
    id: "wishlist-page",
    data: "wishlist",
    events: {
      "click a[data-wk-share]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.requestWishlistSharing({
          wkShareService: event.currentTarget.getAttribute(
            "data-wk-share-service"
          ),
          wkShare: event.currentTarget.getAttribute("data-wk-share"),
          wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
        });
      },
    },
    template: `
      <div class='WL_Container {% if wishlist.read_only %}wk-page--shared{% endif %}'>
      {% if wishlist.item_count == 0 %}
<style>
.Main_PageHeader{display:none;}
</style>
          <div class="wk-note wk-note__list-empty">

  <header class="PageHeader--- Empty_PageHeader EmptyState">
    <div class="Container">
      <div class="SectionHeader SectionHeader--center">
        <h1 class="SectionHeader__Heading Heading u-h1">{% if customer.first_name  %}{{ customer.first_name }}'s{% endif %} WISHLIST is empty</h1>
        <div class="">
        <p>Add items to your Wishlist by pressing the heart icon whilst you shop.</p> 
        {% if customer %}
        <p>As your logged in, we'll sync your items across all your devices.</p>
        {% else %}
        <p>
        <a onclick="myLoginF()" href="javascript:void(0);" class="Link Link--underline letter-spacing-body color-light openLogForm" data-action="open-modal" aria-controls="Main_Registeration_Popup"><span>Login</span></a>
        or
        <a onclick="myRegisterF()" href="javascript:void(0);" class="Link Link--underline letter-spacing-body color-light openRegForm" data-action="open-modal" aria-controls="Main_Registeration_Popup">Create an account</a>
        to sync your items across all your devices.</p>
        {% endif %}
        
        </div> 
         <div class="ButtonGroup ButtonGroup--spacingSmall justify-content-center">
          <a href="/collections/all-mens-clothing" class="ButtonGroup__Item Button Button--primary Button--large btn-accent-primary">Shop Men's</a>
          <a href="/collections/all-womens-clothing" class="ButtonGroup__Item Button Button--primary Button--large btn-accent-primary">Shop Women's</a>
         </div>
        </div>
    </div>
  </header>
  
            
          </div>

      {% else %}

        {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
          <div class="wk-note wk-note__login">
            <p>{{ locale.login_or_signup_note }}</p>


    
       <div class="ButtonGroup ButtonGroup--spacingSmall">
            
            <a class="ButtonGroup__Item Button Button--small btn-less-padding btn-white openRegForm" data-action="open-modal" aria-controls="Main_Registeration_Popup">JOIN for free</a>
           -----
            <a class="ButtonGroup__Item Button Button--small btn-less-padding  openLogForm" data-action="open-modal" aria-controls="Main_Registeration_Popup">Sign in</a>

          </div>
 
          
          
          
          
          </div>



          
        {% endif %}

   <div class="CollectionToolbar CollectionToolbar--top">
      <div class="WL_Results_Header d-flex justify-content-between align-items-center">      
        <span class="WL_Results_Count u-h8 letter-spacing-2 uppercase color-light Search_Results_Count">{% if wishlist.item_count == 1 %}{{wishlist.item_count}} Item {% else %} {{wishlist.item_count}} Items{% endif %}</span> 
{% assign bundle_present = false %}
{% assign products = wishlist.products | reverse %}
{% for product in products %}
  {% if product.handle contains 'boxraw-conditioning-pack' or product.handle contains 'test-product-black' %}
    {% assign bundle_present = true %}
  {% endif %}
{% endfor %}
        {% if wishlist.item_count == 1 %}    
        {% elsif wishlist.item_count == 2 and bundle_present == true %}
        {% elsif wishlist.item_count == 2 and bundle_present == false %}
          <a class="WL_ATC_Link u-h8 uppercase Link Link--underline color-light" href="#">ADD BOTH TO CART</a>
        {% elsif wishlist.item_count == 3 and bundle_present == true %}
          <a class="WL_ATC_Link u-h8 uppercase Link Link--underline color-light" href="#">ADD BOTH TO CART</a>
        {% else %}
          <a class="WL_ATC_Link u-h8 uppercase Link Link--underline color-light" href="#">ADD ALL TO CART</a>
        {% endif %}
       </div>
  </div>
        

<script>

</script>


        
<div class="ProductList ProductList--grid ProductList--removeMargin Grid" data-page_prev="1" data-page="1" data-mobile-count="2" data-desktop-count="5">
           
            {% assign item_count = 0 %}
            {% assign products = wishlist.products | reverse %}
            
            {% for product in products %}
              {% assign item_count = item_count | plus: 1 %}
              {% unless limit and item_count > limit %}
                {% assign hide_default_title = false %}
                {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                  {% assign hide_default_title = true %}
                {% endif %}

                {% assign variant = product.selected_or_first_available_variant %}
                {% if variant.price < variant.compare_at_price %}
                  {% assign onsale = true %}
                {% else %}
                  {% assign onsale = false %}
                {% endif %}
                <div class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk">









                
                  <div class="ProductItem {% if onsale %}wk-product--sale{% endif %}" data-price="{{ product.price }}" data-wk-item="{{ product.wishlist_item_id }}">
                  <div class="ProductItem__Wrapper">
                  <div class="Product_Thumb_Img_Wrapper">



{% assign new_releases_men_women = '' %}
{% assign creed_tag = '' %}
{% for tag in product.tags %}
	{% if tag == 'new-releases-men' or tag == 'new-releases-women' %}
       	{% assign new_releases_men_women = 'new-releases' %}
    {% endif %}
    	{% if tag == 'creed' %}
       	{% assign creed_tag = 'true' %}
    {% endif %}
{% endfor %}

{% assign checkforcomingsoontagcheck = false %}
{% assign checkforpreordertagcheck = false %}

{% for tag in product.tags %}
  {% if tag contains 'coming' %}
    {% assign checkforcomingsoontagcheck = true %}

      {% elsif tag contains 'pre-order' %}
          {% assign checkforpreordertagcheck = true %}

  {% else %}

  {% endif %}
{% endfor %}  

 

<div class="ProductItem__LabelList">
    {% if checkforcomingsoontagcheck == true %}
          <span class="ProductItem__Label ComingSoon__Badge uppercase color-white font-weight-thin" >COMING SOON</span>
          
        {% elsif checkforpreordertagcheck == true %}
          <span class="ProductItem__Label PreOrder__Badge uppercase color-white font-weight-thin" >PRE-ORDER</span>

           {% elsif product.handle contains 'boxraw-conditioning-pack' or product.handle contains 'test-product-black' %}
          <span class="ProductItem__Label PDPItem__Tag Discount_Tag uppercase color-white font-weight-thin" >{{ product.selected_or_first_available_variant.compare_at_price | minus: product.selected_or_first_available_variant.price | money }} OFF</span>
          
          {% elsif variant.compare_at_price  > variant.price   %}
          
          <span class="ProductItem__Label Discount__Badge uppercase color-white font-weight-thin">{{ product.selected_or_first_available_variant.compare_at_price | minus:product.selected_or_first_available_variant.price | times:100 | divided_by:product.selected_or_first_available_variant.compare_at_price  | round: 0}}% OFF</span>
        
          {% elsif product.available == false %}
          	<span class="ProductItem__Label SoldOut__Badge uppercase color-white font-weight-thin">Sold out</span>
          
          {% elsif new_releases_men_women != '' %}
          <span class="ProductItem__Label NewRelease__Badge uppercase color-white font-weight-thin" >NEW</span> 
          
          {% endif %} 
       
</div>










 
<span class="detect_sharedwishlist_template">
                    {% unless wishlist.read_only %}
                      {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                    {% else %}
                      {% include "wishlist-button-floating" product: product %}
                    {% endunless %}
</span>

                    
<a href="{{ product | variant_url }}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage" title="{{ locale.view_product }}">
    <div class="AspectRatio AspectRatio--withFallback" style="max-width: 1079px; padding-bottom: 125.11584800741429%; --aspect-ratio: 0.7992592592592592"> 
    
                 {% for image in product.images limit:2 %}
                  {% assign secound_image = image.src %}
                {% endfor %} 
                
    <!-- <img class="Image--lazyLoad Image--fadeIn ProductItem__Image" src="{{ secound_image }}" >-->
     
      <img class="Image--lazyLoad Image--fadeIn ProductItem__Image--alternate" src="{{ secound_image }}" data-srcset="{{ secound_image }}" srcset="{{ $product.media?.alt?.src ?? $product.media.default.src | resize_image 500 }}">
      
      <img class="Image--lazyLoad Image--fadeIn ProductItem__Image" src="" data-srcset="{{ product | variant_img_url: '1000x' }}" alt="Hagler Sauna Suit 2.0 - Navy" srcset="{{ product | variant_img_url: '1000x' }}">
    

    <span class="Image__Loader"></span> 
      
    </div>
</a>


{% assign support-type_medium = false %}
{% assign hide_free_shipping_badge = false %}

{% for tag in product.tags %}
  {% if tag contains 'support-type_medium' %}
    {% assign support-type_medium = true %}

 {% elsif  tag contains 'hide-free-shipping-badge'  %}

      {% assign hide_free_shipping_badge = true %}

  {% else %}

  {% endif %}
{% endfor %}  


{% if hide_free_shipping_badge == true %}
{% else %}
 <div class="Product__Label includes_free_shipping"><span class="uppercase font-weight-thin">INCLUDES FREE SHIPPING</span></div>
{% endif %}



{% if support-type_medium == true %}
 <div style="display:none" class="Product__Label support-type_medium"><span class="uppercase font-weight-thin">Medium Support</span></div>
{% endif %}

 {% if creed_tag != '' %}
              <div  class="ProductItem__Label Creed_As_Seen_Badge Creed_As_Seen_Badge_PLP d-flex flex-flow-column align-items-center">
              <span class="uppercase u-h8 font-weight-thin">Seen In</span>
              <img class="Creed_logo" src="https://cdn.shopify.com/s/files/1/0019/4497/7466/files/Creed_Logo_white.png?v=1676382484">
            </div>	
            {% else %}
            
        {% endif %} 

                    </div>

                    <div class="ProductItem__Info ProductItem__Info--left">
                     
                      <a class="ProductItem__TitleWrapper" href="{{ product | variant_url }}">
                        
                          
                          <h2 class="ProductItem__Title u-h6 font-weight-600">
                          {% assign product_title_wishlist = product.title | split: " - " %}	
                        {{product_title_wishlist[0]}}	
                       <span class="Product_Color color-grey font-weight-400"> {{product_title_wishlist[1]}}</span>	
                   </h2>


                   
                      </a>
                       
                      <div class="ProductItem__PriceList u-h6">


                      
                      {% if variant.compare_at_price %}

                        <span class="ProductItem__Price Price Price--highlight">{{ variant.price | money }}</span>
                      
                      <span class="ProductItem__Price Price Price--compareAt">{{ variant.compare_at_price | money }}</span>
                       
                    
                    
                      {% else %}
                        <span class="ProductItem__Price Price">{{ variant.price | money }}</span>
                      
                      {% endif %}
                      </div>
                    </div>

                    {% include "wishlist-product-form" %}
                  </div>
                </div>
                </div>
              {% endunless %}
            {% endfor %}
          </div>
         
<div class="WL_BtnsRow  ButtonGroup justify-content-center--- ButtonGroup--spacingSmall"> 
 {% include "wishlist-button-bulk-add-to-cart" %} 
    {% unless wishlist.read_only %}
      {% include "wishlist-button-clear" %}
    {% endunless %} 
</div>

    

        {% unless wishlist.read_only %}
          <div class="Product_SocialSharing WL_SocialSharing text-center">
            <h4 class="Heading u-h3">{{ locale.share_wishlist }}</h4>
            <ul class="sharingList d-flex justify-content-center col-gap-15">


            
              <li class="url copy_shared_wishlist_url_from_wishlist_page">{% include "wishlist-share-button-link" %}</li>


              
              <li class="fb">{% include "wishlist-share-button-fb" %}</li>
              <li class="tw">{% include "wishlist-share-button-twitter" %}</li> 
              <li class="env">{% include "wishlist-share-button-email" %}</li>
              <li class="wa">{% include "wishlist-share-button-whatsapp" %}</li>
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
            </ul>
            <div style="display:none" class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
          </div>
        {% endunless %}
      {% endif %}
      </div>
{% if customer %}
{% else %}
<div class="WL_Sync_Section text-center detect_sharedwishlist_template">


<svg viewBox="0 0 200 200">
<path d="M170.682,170.72c-8.234,8.233-17.699,14.852-28.088,19.776c-10.081,4.771-20.777,7.772-31.936,8.927
	c-3.463,0.385-7.08,0.538-10.62,0.538c-17.007,0-33.782-4.309-48.557-12.543l-6.387,8.311c-0.385,0.463-1,0.77-1.616,0.693
	c-0.616-0.077-1.154-0.462-1.385-1.078l-10.851-26.317c-0.231-0.538-0.154-1.231,0.231-1.77c0.385-0.462,1-0.77,1.616-0.692
	l28.241,3.771c0.616,0.077,1.154,0.462,1.385,1.077c0.231,0.539,0.154,1.231-0.231,1.693l-6.002,7.771
	c16.16,8.695,35.013,12.313,53.328,10.389c10.235-1.077,20.085-3.848,29.319-8.234c9.541-4.539,18.237-10.619,25.855-18.16
	c32.859-32.859,36.014-85.187,7.388-121.662c-1.386-1.77-1.077-4.31,0.692-5.694c0.847-0.693,1.924-1,3.002-0.847
	c1.076,0.154,2,0.692,2.693,1.539C209.85,78.068,206.464,134.937,170.682,170.72z M151.365,110.619
	c-11.312,18.623-31.627,34.938-46.709,45.326l-4.695,3.231l-4.617-3.231c-17.545-12.313-41.862-31.32-50.942-53.867
	c-4.694-11.082-3.54-24.164,3.155-34.321c6.156-9.388,16.083-14.852,27.087-14.852h0.308c6.002,0,11.927,1.616,17.16,4.617
	l0.077,0.077l0.077,0.077c2.847,1.77,5.387,3.771,7.619,5.925l0,0c1.23-1.154,2.77-2.54,4.309-3.771
	c5.695-4.54,13.006-7.08,20.624-7.08c9.234,0,18.007,3.694,24.009,10.158c5.232,5.387,8.234,12.236,9.312,20.931
	C159.292,92.458,157.061,101,151.365,110.619z M168.526,32.667c-0.385,0.461-1.001,0.77-1.616,0.692l-27.703-3.771
	c-0.615-0.077-1.154-0.462-1.385-1.078c-0.23-0.615-0.154-1.231,0.23-1.77l5.849-7.464c-16.237-8.773-35.167-12.543-53.559-10.62
	c-10.234,1.077-20.162,3.848-29.473,8.157c-9.619,4.541-18.315,10.62-25.933,18.238C19.238,50.827,9.773,71.758,8.311,93.998
	c-1.462,22.008,5.079,43.786,18.314,61.332c0.616,0.847,0.923,1.924,0.77,3.001s-0.692,2.001-1.539,2.693
	c-0.692,0.539-1.539,0.847-2.462,0.847c-1.308,0-2.462-0.616-3.232-1.616C5.694,141.093-1.385,117.391,0.231,93.459
	c1.616-24.163,11.928-46.941,29.088-64.102c8.234-8.234,17.699-14.929,28.165-19.854c10.081-4.771,20.854-7.772,32.013-8.927
	c20.469-2.155,41.478,2.155,59.407,12.235l6.233-8.08c0.385-0.461,1-0.77,1.615-0.692c0.616,0.077,1.154,0.462,1.386,1.077
	l10.62,25.856C168.988,31.512,168.911,32.205,168.526,32.667z"/>
</svg>

  <p>Login to sync your Wishlist across all your devices.</p>
  <a onclick="myLoginF()" href="javascript:void(0);" class="Button Button--primary Button--large openLogForm" data-action="open-modal" aria-controls="Main_Registeration_Popup">Login</a>
  <div class="Form__Hint Form__Hint--center">
  Don’t have an account?  
        <a href="javascript:void(0);" onclick="myRegisterF()" class="Link Link--underline letter-spacing-body font-weight-bold openRegForm" data-action="open-modal" aria-controls="Main_Registeration_Popup">Create one</a>
   
      </div>
      
</div>
     {% endif %}
    `,
  },
  {
    id: "wishlist-product-form",
    events: {
      "render .wk-product-form": (form) => {
        const container = form.closest("[data-wk-item]");
        const itemId = container.getAttribute("data-wk-item");
        WishlistKing.toolkit.getItem(itemId).then((product) => {
          WishlistKing.toolkit.initProductForm(form, product, {
            // NOTE: Uncomment to override default option change
            // onOptionChange: (event) => {
            //   console.log(event.dataset);
            // },
            // NOTE: Uncomment to override default form submit
            // onFormSubmit: (event) => {
            //   event.preventDefault();
            //   event.stopPropagation();
            // },
          });
        });
      },
    },
    template: `
      <form class="wk-product-form" action="/cart/add" method="post">
        {% assign current_variant = product.selected_variant %}
        <div class="wk-product-form__options">

    {% assign checkforcomingsoon = false %}
    {% assign checkforpreorder = false %}

{% assign hide_quick_add = false %}


{% for tag in product.tags %}
  {% if tag contains 'coming' %}
    {% assign checkforcomingsoon = true %}

{% elsif tag contains 'pre-order' %}
 {% assign checkforpreorder = true %}

{% elsif tag contains 'hide-quick-add' %}
    {% assign hide_quick_add = true %}
    
  {% else %}
  {% endif %}
{% endfor %}  
  
         {% if product.available == false %}
          <input name="id" value="" type="hidden" class="current_sku_single_product_wishlist">
         {% else %}
         {% if checkforcomingsoon == true or  product.handle contains 'boxraw-conditioning-pack' or product.handle contains 'test-product-black' %}
          <input name="id" value="" type="hidden" class="current_sku_single_product_wishlist bundle-product">

{% elsif checkforpreorder == true %}
          <input name="id" value="" type="hidden" class="current_sku_single_product_wishlist ">
         
{% else %}
          <input name="id" value="{{ current_variant.id }}" type="hidden" class="current_sku_single_product_wishlist">

{% endif %}

{% endif %}
          
          {% if product.has_only_default_variant %}
         <div class="invisible-select"></div>
          {% else %}
            
            {% for option in product.options_with_values %}
              <div class="wk-product-form__option">
                <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                </label>
             
         
             
       {% if product.available == false %}

<span class="wk-product-form__option__select atc-select-oos letter-spacing-body u-h6 wishlist-fake-select">
      Select Size
 </span>

 {% elsif hide_quick_add == true %}
  
   {% elsif hide_quick_add == true %}      
                 
     {% else %}

{% if checkforcomingsoon == true %}
<span class="wk-product-form__option__select atc-select-oos letter-spacing-body u-h6 wishlist-fake-select">
      Select Size
 </span>

 {% elsif checkforpreorder == true %}

  

   
{% else %}


                
 <select class="wk-product-form__option__select letter-spacing-body u-h6" name="options[{{ option.name | escape }}]">
      {% if current_variant.id == null or current_variant.id == ""%}
          <option value="select_size" selected="selected" id="selected_option" > Select Size </option>
        {% for value in option.values %}
          <option value="{{ value | escape }}"  {% if option.selected_value == value %} id="selected_option"{% endif %} {% if option.soldout_values contains value %}disabled="disabled" {% endif %}>
            {{ value }}
          </option>
        {% endfor %}
      {% else %}
          <option value="select_size" id="selected_option" > Select Size </option>
      
        {% for value in option.values %}
          <option value="{{ value | escape }}" {% if option.selected_value == value %}selected="selected" id="selected_option"{% endif %} {% if option.soldout_values contains value %}disabled="disabled" {% endif %}>
            {{ value }}
          </option>
        {% endfor %}
      {% endif %}
 </select>
{% endif %}

 
{% endif %}




                
              </div>
            {% endfor %}


            
          {% endif %}



          
          {% comment %}
          <div class="wk-product-form__quantity">
            <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
            <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
          </div>
          {% endcomment %}
        </div>
<style>
.wk-product-form__submit{
display:none !important;
}
</style>
     
        <button type="submit" class="wk-product-form__submit" data-wk-add-to-cart="{{ product.wishlist_item_id }}" {% unless current_variant.available %}disabled{% endunless %}>
          {% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}
        </button>



{% if checkforcomingsoon == true %}
<button  type="button" class="Button Button--full atc-btn-oos " disabled >
          Coming Soon
        </button>
        
{% elsif checkforpreorder == true %}

 <a class="btn-accent-primary Button Button--full" href="{{ product.url }}">View Product </a>

{% elsif hide_quick_add == true %}
   
        <a class="btn-accent-primary Button Button--full" href="{{ product.url }}">View Product </a>
        
{% else %}

{% if product.available == false %}
<button  type="button" class="Button Button--full atc-btn-oos " disabled >
          OUT OF STOCK
        </button>
{% else %}

{% if product.handle contains 'boxraw-conditioning-pack' or product.handle contains 'test-product-black' %}
  <a class="btn-accent-primary Button Button--full" href="{{ product.url }}">View Bundle </a>
{% else %}
  {% if current_variant.id == null or current_variant.id == ""%}
     <button  type="button" class="atc-btn-disabled Button Button--full wk-product-form__submit_check_size"  >
            Add to cart
     </button>
  {% else %}
      <button  type="button" class="btn-accent-primary Button Button--full wk-product-form__submit_check_size"  >
            Add to cart
      </button>
  {% endif %}   
{% endif %}

{% endif %}
{% endif %}
        
      </form>

      
    `,
  },
  {
    id: "wishlist-page-shared",
    data: "shared_wishlist",
    template: `
      {% assign wishlist = shared_wishlist %}
      {% include "wishlist-page" with wishlist %}
    `,
  },
  {
    id: "wishlist-button-bulk-add-to-cart",
    data: "wishlist",
    events: {
      "click button[data-wk-bulk-add-to-cart]": (event) => {
        WishlistKing.toolkit.requestAddAllToCart(
          event.currentTarget.getAttribute("data-wk-bulk-add-to-cart")
        );
      },
    },
    template: `
      {% assign btn_text = locale.add_all_to_cart %}
      {% assign btn_title = locale.add_all_to_cart %}
 

<style>
.wk-button-bulk-add-to-cart_check_select_size{
  display:none;
}
</style>

<button type="button" class="ButtonGroup__Item Button Button--primary Button--large wk-button-bulk-add-to-cart_check_select_size" title="{{ btn_title }}" ">
        <span class="wk-label">{{ btn_text }}</span>
      </button>

      <button type="button" class="ButtonGroup__Item Button Button--primary Button--large wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
 
    `,
  },
  {
    id: "wishlist-button-clear",
    data: "wishlist",
    events: {
      "click button[data-wk-clear-wishlist]": (event) => {
        WishlistKing.toolkit.clear(
          event.currentTarget.getAttribute("data-wk-clear-wishlist")
        );
      },
    },
    template: `
      {% assign btn_text = locale.clear_wishlist %}
      {% assign btn_title = locale.clear_wishlist %}
      
<span class="detect_sharedwishlist_template">

      <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
        <svg viewBox="0 0 200 200">
<path d="M181.73,18.846h-41.538V5.385c0-3.077-2.308-5.385-5.385-5.385h-69.23c-3.077,0-5.385,2.692-5.385,5.385v13.461H17.885
  c-3.077,0-5.385,2.692-5.385,5.769v18.077c0,3.077,2.308,5.385,5.385,5.385h8.846l14.615,146.538
  c0.385,3.077,2.692,5.385,5.385,5.385h106.154c3.076,0,5.385-2.308,5.385-5l14.615-146.539h8.846c3.077,0,5.385-2.308,5.385-5.384
  V24.615C187.5,21.539,184.808,18.846,181.73,18.846z M72.5,7.308h54.615c0.77,0,1.539,0.77,1.539,1.539v10H70.961V9.231
  C70.961,8.077,71.731,7.308,72.5,7.308z M147.885,188.846h-95.77L37.885,48.077H161.73L147.885,188.846z M179.039,40H20.961V27.308
  h158.461V40H179.039z M140.961,68.077l-7.691,100c0,2.308-2.309,4.23-4.615,4.23h-0.385c-1.154,0-2.309-0.769-3.077-1.538
  c-0.77-0.77-1.153-2.309-1.153-3.462l7.691-100c0-2.692,2.309-4.615,5-4.23c1.154,0,2.309,0.769,3.077,1.538
  C140.577,65.769,140.961,66.923,140.961,68.077z M104.423,67.692v100.385c0,2.692-1.923,4.615-4.615,4.615s-4.615-1.923-4.615-4.615
  V67.692c0-2.692,1.923-4.615,4.615-4.615S104.423,65,104.423,67.692z M76.731,167.308c0,1.153-0.385,2.308-1.154,3.462
  c-0.77,0.77-1.923,1.538-3.077,1.538c-2.692,0-4.615-1.923-5-4.23l-7.692-100c0-2.692,1.539-4.616,4.231-5
  c2.692,0,4.615,1.538,5,4.23L76.731,167.308z"/>
</svg>
        <span class="wk-label Link Link--underline uppercase u-h8">{{ btn_text }}</span>
      </button>
      </span>

    `,
  },
  {
    id: "wishlist-icon",
    template: `  
<svg class="wk-icon__svg" viewBox="0 0 200 200"> 
<path d="M142.347,9.584L142.347,9.584c-13.189,0-25.686,4.165-35.057,12.148c-2.43,2.083-4.859,4.166-7.289,6.248l0,0
	c-3.818-3.818-7.983-7.289-12.842-10.065l0,0l0,0c-9.024-5.207-19.09-7.983-29.156-7.983h-0.694c-19.09,0-35.75,9.371-46.51,25.337
	C-0.655,52.623-2.39,74.837,5.593,93.58c15.272,38.18,56.576,70.458,86.425,91.632l7.983,5.554l7.983-5.554
	c25.685-17.702,60.047-45.469,79.483-77.054c9.72-16.313,13.536-30.892,11.802-45.816c-1.735-14.925-6.942-26.379-15.967-35.403
	C172.891,15.832,157.966,9.584,142.347,9.584L142.347,9.584z"/>
</svg>
    `,
  },
  {
    id: "remove-icon",
    template: `
      <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path vector-effect="non-scaling-stroke" d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"/>
        <path vector-effect="non-scaling-stroke" d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"/>
      </svg>
    `,
  },
  {
    id: "wishlist-share-button-fb",
    data: "wishlist",
    template: `
      <a href="#" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-twitter",
    data: "wishlist",
    template: `
      <a href="#" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
        <path fill="currentColor" d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-whatsapp",
    data: "wishlist",
    template: `
      <a href="#" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-email",
    data: "wishlist",
    template: `
      <a href="#" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24"">
          <path fill="currentColor" d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-link",
    data: "wishlist",
    template: `
   
      <a href="#" class="main_wishlist_copyButton"  title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}"
      
        onClick="wishlist_share_url_button();" >
        
        <svg class='CopyIcon' viewBox='0 0 512 512'>
          <path fill="currentColor" d='M459.654,233.373l-90.531,90.5c-49.969,50-131.031,50-181,0c-7.875-7.844-14.031-16.688-19.438-25.813
            l42.063-42.063c2-2.016,4.469-3.172,6.828-4.531c2.906,9.938,7.984,19.344,15.797,27.156c24.953,24.969,65.563,24.938,90.5,0
            l90.5-90.5c24.969-24.969,24.969-65.563,0-90.516c-24.938-24.953-65.531-24.953-90.5,0l-32.188,32.219
            c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984,131.031-49.984,181.031,0
            C509.623,102.342,509.623,183.389,459.654,233.373z M220.326,382.186l-32.203,32.219c-24.953,24.938-65.563,24.938-90.516,0
            c-24.953-24.969-24.953-65.563,0-90.531l90.516-90.5c24.969-24.969,65.547-24.969,90.5,0c7.797,7.797,12.875,17.203,15.813,27.125
            c2.375-1.375,4.813-2.5,6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828c-49.969-49.984-131.031-49.984-181.016,0
            l-90.5,90.5c-49.984,50-49.984,131.031,0,181.031c49.984,49.969,131.031,49.969,181.016,0l68.594-68.594
            C274.561,395.092,246.42,392.342,220.326,382.186z'/>
        </svg>
          
            <svg style="display:none" class="wishlist_urlloader_loader" viewBox="0 0 50 50" class="CheckIcon" style=""><g stroke="none" stroke-width="1" fill="none"><polygon fill="#fff" points="14.6553946 35.392902 5.19935444 25.8272493 0 31.0869305 12.4784711 43.7100827 12.4927896 43.6954946 14.7708631 46 50 10.3619014 44.6998024 5"></polygon></g></svg>
            
            
            </a>


    `,
  },
  {
    id: "wishlist-share-button-contact",
    data: "wishlist",
    template: `
      <a href="#" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
        <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </a>
    `,
  },
];

export default templates;
